const STYLES = [
  { id: "classic", label: "Classic" },
  { id: "smirk", label: "Smirk" },
  { id: "smile", label: "Smile" },
  { id: "frown", label: "Frown" },
];

const Label = ({ children }) => <p className="text-xs font-mono2 uppercase tracking-widest text-muted-foreground mb-3">{children}</p>;

// Step 1 picker: duck expression (only meaningful for AI renders).
export const RenderPickers = ({ style, onStyle, showStyle = true }) =>
  showStyle ? (
    <div>
      <Label>Duck expression</Label>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {STYLES.map((s) => (
          <button
            key={s.id}
            type="button"
            data-testid={`style-${s.id}`}
            onClick={() => onStyle(s.id)}
            className={`rounded-full py-2.5 text-sm font-semibold border transition-colors ${
              style === s.id ? "bg-primary text-primary-foreground border-primary" : "bg-background border-border hover:border-primary"
            }`}
          >
            {s.label}
          </button>
        ))}
      </div>
    </div>
  ) : null;
